import { QUESTIONNAIRE_TEMPLATE_DETAILS } from "../_constants/questionnaireTemplateDetails.constant"
import { getQuestionnaireTemplateDetails } from "../apis/questionnaireApis"

export const clearQuestionnaireTemplateDetailsStore = () => {
    return { type: QUESTIONNAIRE_TEMPLATE_DETAILS.CLEAR }
}

const fetchQuestionnaireTemplateDetails = (questionnaireTemplateId , versionId='') => {
    return async (dispatch) => {
        dispatch({ type: QUESTIONNAIRE_TEMPLATE_DETAILS.SET_LOADING_TEMPLATE_DETAILS, data: true });
        try {
            const res = await getQuestionnaireTemplateDetails(questionnaireTemplateId ,versionId)
            dispatch({
                type: QUESTIONNAIRE_TEMPLATE_DETAILS.SET_TEMPLATE_DETAILS_DATA, 
                 data: res.data,
                 version:  res.data.version.toString()
            });
        } catch (e) {
            dispatch({ type: QUESTIONNAIRE_TEMPLATE_DETAILS.SET_LOADING_TEMPLATE_DETAILS, data: false });
        }
    }
}

export const questionnaireTemplateDetailsActions = {
    fetchQuestionnaireTemplateDetails,
    clearQuestionnaireTemplateDetailsStore,
}